import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.remove('no-scroll');
    // Instant scroll to top on route change so new page starts at top without slow scrolling lag
    const root = document.documentElement;
    const prevBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    requestAnimationFrame(() => {
      root.style.scrollBehavior = prevBehavior || 'smooth';
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
